import React,{useEffect} from 'react'
import Navbar from '../nav/Navbar'
import Footer from '../footer/Footer'
// import './news_media.css'
function Schedule_of_charges() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
        <Navbar/>
        <div className='news_media'>
          <h1>SCHEDULE OF CHARGES</h1>
        </div>

		<div className='about_us'>
      <section style={{marginTop:"3rem"}}>
      <h1>SCHEDULE OF CHARGES</h1>
      <div className="table-responsive">
      <table class="table table-bordered table-hover">
      <thead class="table-light">
        <tr>
          <th style={{ textAlign: 'center' }} width="10%"><b>S.No.</b></th>
          <th style={{ textAlign: 'center' }} width="45%"><b>Charge Name</b></th>
          <th style={{ textAlign: 'center' }} width="45%"><b>Charge Amount</b></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>Loan Processing Charges/Review Fees*</td>
          <td>Upto 3% of Loan Amount</td>
        </tr>
        <tr>
          <td>2</td>
          <td>ROI</td>
          <td>Upto 36% Per Annum</td>
        </tr>
        <tr>
          <td>3</td>
          <td>Stamp Duty</td>
          <td>As Per the State's Stamp Act</td>
        </tr>
        <tr>
          <td>4</td>
          <td>Stamping Admin Charges**</td>
          <td>₹ 200</td>
        </tr>
        <tr>
          <td>5</td>
          <td>Penal Charges*</td>
          <td>Up to 3% pm. On the instalment overdue from the due date up to the date of Payment</td>
        </tr>
        <tr>
          <td>6</td>
          <td>Part-Prepayment*</td>
          <td>10% prepayment fee for partial/full prepayment. No partial prepayment allowed in loans less than 12 MOB. Partial prepayments allowed only 2 times in a year. There should be a minimum gap of 4 months between two partial prepayments.</td>
        </tr>
        <tr>
          <td>7</td>
          <td>Foreclosure Charges*</td>
          <td>10% of Outstanding Principal</td>
        </tr>
        <tr>
          <td>8</td>
          <td>Cash Collection Charges (If Cash Deposited for Foreclosure / Prepayment / Repayment / Any Other Charges)*</td>
          <td>Upto 5% of Deposit Amount</td>
        </tr>
        <tr>
          <td>9</td>
          <td>Collection Visit Charges*</td>
          <td>₹ 500 Per Visit</td>
        </tr>
        <tr>
          <td>10</td>
          <td>Cheque/NACH Return Charges*</td>
          <td>₹ 500</td>
        </tr>
        <tr>
          <td>11</td>
          <td>Cheque/Disbursement/Loan Cancellation*</td>
          <td>
            1. During the Cooling Period of 7 Days from Date of Disbursal: No Cancellation Charges & Interest Will be Charged as Per APR of The Respective Case.<br/>
            2. Post Cooling off Period: ₹ 1000 Plus Applicable Interest up to Cancellation Period Will be Charged Subject to Funds Not Used by Customer
          </td>
        </tr>
        <tr>
          <td>12</td>
          <td>Statement of Account Charges*</td>
          <td>₹ 1,000</td>
        </tr>
        <tr>
          <td>13</td>
          <td>Duplicate Amortisation/Repayment Schedule Charges*</td>
          <td>₹ 1,000</td>
        </tr>
        <tr>
          <td>14</td>
          <td>Duplicate Copy of Property Paper/Loan Document Charges*</td>
          <td>₹ 1,000</td>
        </tr>
        <tr>
          <td>15</td>
          <td>Provisional/ Final Interest Certificate*</td>
          <td>₹ 1,000</td>
        </tr>
        <tr>
          <td>16</td>
          <td>List of Documents (LOD)*</td>
          <td>₹ 1,000</td>
        </tr>
        <tr>
          <td>17</td>
          <td>Issue of Duplicate NOC*</td>
          <td>₹ 1000 Per Instance</td>
        </tr>
        <tr>
          <td>18</td>
          <td>Swap Charges (Replacement of PDC/Change of Account)*</td>
          <td>₹ 1,000</td>
        </tr>
        <tr>
          <td>19</td>
          <td>Foreclosure Statement Charges*</td>
          <td>₹ 1000 Per Instance</td>
        </tr>
        <tr>
          <td>20</td>
          <td>Legal/ Sarfeasil/Incidental Charges*</td>
          <td>At Actuals</td>
        </tr>
        <tr>
          <td>21</td>
          <td>Tele Collection Charges*</td>
          <td>₹ 20 Per Instance</td>
        </tr>
        <tr>
          <td>22</td>
          <td>Property Valuation Charges*</td>
          <td>Upto ₹ 5000 Per Property</td>
        </tr>
        <tr>
          <td>23</td>
          <td>Property Legal Charges*</td>
          <td>Upto ₹ 5000 Per Property</td>
        </tr>
        <tr>
          <td>24</td>
          <td>Property Paper Retrieval for Verification/Inspection/For Lease Deed from Development Authority/Nagar Palika*</td>
          <td>₹ 1,000</td>
        </tr>
        <tr>
          <td>25</td>
          <td>Property/Asset / Collateral Swapping Charges*</td>
          <td>₹ 5000 Per Property</td>
        </tr>
        <tr>
          <td>26</td>
          <td>Cersai Charges**</td>
          <td>₹ 300 Per Registration</td>
        </tr>
        <tr>
          <td>27</td>
          <td>Pre RCU/Risk Fl Charge*</td>
          <td>₹ 1,200 Per Instance</td>
        </tr>
        <tr>
          <td>28</td>
          <td>ROC Filling Charges*</td>
          <td>At Actuals</td>
        </tr>
        <tr>
          <td>29</td>
          <td>Progress Report / Subsequent Valuation Report*</td>
          <td>₹ 1,500</td>
        </tr>
        <tr>
          <td>30</td>
          <td>EMI Delay Due to NACH Not Registered*</td>
          <td>₹ 500</td>
        </tr>
        <tr>
          <td>31</td>
          <td>Communication Charges*</td>
          <td>₹ 200 Per Instance</td>
        </tr>
        <tr>
          <td>32</td>
          <td>Login Fee*</td>
          <td>Upto ₹ 5000</td>
        </tr>
        <tr>
          <td>33</td>
          <td>Fl Charges- Per Visit**# (Pre / Post Disbursement Visit Including Any Third Party)</td>
          <td>₹ 1500</td>
        </tr>
      </tbody>
    </table>

    <div class="disclaimer">
      <p>*GST and other government taxes applicable as per prevailing rate will be charged over and above the fees and charges.</p>
      <p>**If stamp duty is purchased by NBFC on behalf of customer.</p>
      <p>### FI Charges: In partnership and co-lending cases this will be applicable based on Term sheet.</p>
      <p>There are no RBI guidelines prescribing minimum/ maximum charges for asset customers. The regulator mentions that the NBFC should have transparency and accordingly disclose the charges prior to entering into agreement with the customer, prior intimation/ adequate disclosure before putting in place modifications.</p>
    </div>
    </div>
    </section>
    </div> 
{/* <section class="news_media_card-container">

	<div class="news_media_card">
  <p className='span'>July 23, 2019</p>

		<p>TPG invests more money in kaabil Finance</p>
    <button class="business_button">Know More</button>
	</div>

	<div class="news_media_card">
 <p className='span'>July 23, 2019</p>

		<p>TPG invests more money in kaabil Finance.</p>
    <button class="business_button">Know More</button>
	</div>

	<div class="news_media_card">
 <p className='span'>July 23, 2019</p>

		<p>TPG invests more money in kaabil Finance.</p>
    <button class="business_button">Know More</button>
	</div>

	<div class="news_media_card">
 <p className='span'>July 23, 2019</p>

		<p>TPG invests more money in kaabil Finance.</p>
    <button class="business_button">Know More</button>
	</div>

	<div class="news_media_card">
 <p className='span'>July 23, 2019</p>
	
		<p>TPG invests more money in kaabil Finance.</p>
    <button class="business_button">Know More</button>
	</div>

	<div class="news_media_card">
  <p className='span'>July 23, 2019</p>

		<p>TPG invests more money in kaabil Finance.</p>
    <button class="business_button">Know More</button>
	</div>

	<div class="news_media_card">
 <p className='span'>July 23, 2019</p>
		<p>TPG invests more money in kaabil Finance.</p>
    <button class="business_button">Know More</button>
	</div>	
  <div class="news_media_card">
 <p className='span'>July 23, 2019</p>

		<p>TPG invests more money in kaabil Finance.</p>
    <button class="business_button">Know More</button>
	</div>
  
	<div class="news_media_card">
 <p className='span'>July 23, 2019</p>
		<p>TPG invests more money in kaabil Finance.</p>
    <button class="business_button">Know More</button>
	</div>	
  <div class="news_media_card">
 <p className='span'>July 23, 2019</p>

		<p>TPG invests more money in kaabil Finance.</p>
    <button class="business_button">Know More</button>
	</div>
	<div class="news_media_card">
 <p className='span'>July 23, 2019</p>
		<p>TPG invests more money in kaabil Finance.</p>
    <button class="business_button">Know More</button>
	</div>	
  <div class="news_media_card">
 <p className='span'>July 23, 2019</p>

		<p>TPG invests more money in kaabil Finance.</p>
    <button class="business_button">Know More</button>
	</div>

</section> */}


        <Footer/>

    </div>
  )
}

export default Schedule_of_charges